import React, {useContext, useState} from "react";
import {
  Button,
  ButtonGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Typography,
  Link
} from "@one-thd/sui-atomic-components";
import { useFormik } from "formik";
import { FieldError } from "../../../../common/fields";
import { ComposedTextFields } from "../../../../common/StencilTextField"
import { OtpLoadingView } from "../../../../NewVerifyOtpModal/OtpModalViews"
import { getOTPv2, passwordlessEnrollmentVerifyOTP } from "../../../../../api/custAccountApi";
import { useCommonContext } from "../../../CommonProvider"
import { MESSAGE_TYPE, MESSAGE } from "../../../../../constants/messages";
import { handleApiError } from "../../../../../utils/errors";
import { useCustomerAccount } from "../../../AccountProvider";
import analytics  from "../../../../../utils/analytics";
import {
  isNativeApp,
  postDataToEventBus,
  isWebAuthnEnabled
} from "../../../../../utils";
import { CompletionMessageComponent } from "../index";
import {PasswordContext} from "../../../../../contexts/PasswordContext";


export const PasswordlessEnrollmentModal = (props) => {

  const {
    open,
    status,
    handleClose,
    email,
    payload,
    setEnrollmentStatus,
    errors,
    setError,
    setEncryptedPayload,
    modalState,
    setModalState,
    isCurrentDeviceWebAuthnCapable,
    isUserPasswordlessEnrolled,
  } = props;

  const {addAlert} = useCommonContext();
  const [isVerified , setIsVerified] = useState(false);
  const [otp, setOTP] = useState("");
  const context = useCustomerAccount();
  const { setStale } = context;

  const {setPasswordOptions} = useContext(PasswordContext)

  const isFSEnabledForEnrollmentAndDeviceCapable = () => {
    return (isWebAuthnEnabled() && isCurrentDeviceWebAuthnCapable );
  }

  const isFSEnabledForUpgradeAndIsPasswordlessEnrolled = () => {
    return (isWebAuthnEnabled() && isUserPasswordlessEnrolled);
  }

  const [ frState, setfrState ] = React.useState(null);

  const webAuthnEnrollmentProcess = (script) => {
    setfrState(script);
  }

  const verifyOtpForm = useFormik({
    initialValues: {
      otp: "",
    },
    validateOnChange: true,
    validateOnBlur: true,
    validateOnMount: true,

    onSubmit: (values, actions) => {
      setModalState("Loading");
      // showLoading();
      const {otp} = values;
      const cleanupForm = () => {
        setOTP("");
        actions.resetForm({values:{"otp": ""}});
      }

      passwordlessEnrollmentVerifyOTP(email, payload, otp, (isFSEnabledForEnrollmentAndDeviceCapable() || isFSEnabledForUpgradeAndIsPasswordlessEnrolled()) ? "WEBAUTHN" : "OTP").then(({response, error}) => {
        // WEBAUTHN FLOW | DEVICE CAPABLE | FS ENABLED
        if (response && response.data.enrollmentCompleted && isFSEnabledForEnrollmentAndDeviceCapable() && (response.data.frState || isNativeApp())) {
          setEnrollmentStatus("SucessfulOTPEnrollment");
          setModalState("SuccessfulVerifyOTP");
          setIsVerified(false);
          cleanupForm();
          analytics.postSettingsSubmissionEvent("passwordless enrollment complete");
          return webAuthnEnrollmentProcess(response?.data?.frState);
        }
        // OLD PASSWORDLESS FLOW | OTP
        if(response && response.data.enrollmentCompleted) {
          setEnrollmentStatus("Success");
          // Notify the Native App a user has successfully enrolled into passwordless
          if(isNativeApp()) {
            postDataToEventBus("NATIVE_APP.PASSWORDLESS_ENROLLMENT", { status: "successful" });
          }
          cleanupForm();
          handleClose();
          setStale();
          addAlert(MESSAGE_TYPE.SUCCESS, MESSAGE.SUCCESS_PASSWORDLESS_ENROLLMENT );
          analytics.postSettingsSubmissionEvent("passwordless enrollment complete");
        } else if (response && response.data.otpVerified === false){
          setEnrollmentStatus("Failure");
          cleanupForm();
          setModalState("info");
          setError(["This code is incorrect."]);
          setEncryptedPayload(response?.data?.encryptedPayload);
        } else {
          setEnrollmentStatus("Failure");
          cleanupForm();
          handleClose();
          setPasswordOptions("password");
          addAlert(MESSAGE_TYPE.DANGER, MESSAGE.SOMETHING_WENT_WRONG);
          handleApiError(error, "passwordless enrollment");
        }
        setIsVerified(false);
        !isWebAuthnEnabled() && setModalState("info");
      });
    },
  });

  const cleanupForm = () => {
    setOTP("");
    verifyOtpForm.resetForm({values:{"otp": ""}});
  }

  const onOtpChange = (e) => {
    const otp = e.trim().replace(/[^\d]/, "");
    verifyOtpForm.setFieldValue("otp", otp, true);
  };

  // 1st STEP: GET OTP || 1st STEP: GET OTP new code.
  const handleNewOTPCode = (email) => {
    setModalState("Loading");
    getOTPv2(email)
      .then(({response, error})=>{
        setError([]);
        setModalState("info");
        if(response?.data?.encryptedPayload) {
          // Successfully received encrypted payload from GET OTP request.
          setEncryptedPayload(response.data?.encryptedPayload)
        } else if (error) {
          const errorMessage = handleApiError(error, "passwordless enrollment");
          setError([errorMessage]);
        }
      })
  }

  const renderError = () => {
    return (
        <div className="form-input--error">
          <FieldError name="otp" errors={errors}/>
        </div>
    )
  }

  const renderView = () => {
    const textInfoCode = "Didn't receive the code?"
    if (modalState==="info") {
      return (
        <>
          <Typography variant="body-base">
            To start signing into your account without a password, enter the verification code we emailed to <strong>{email}</strong>.
          </Typography>
          <br/>
          <ComposedTextFields submit={ verifyOtpForm.handleSubmit } errors={ errors ? renderError() : null } onOtpChange={onOtpChange} setOTP={setOTP} otp={otp} isVerified={ isVerified } setVerify={ setIsVerified } fullWidth type={"OTP"} inputProps={{ maxLength: 6}}/>
          <br/>
          <Typography variant="body-base">
            {textInfoCode}
          </Typography>
          <br/>
          <Link  onClick={ () => handleNewOTPCode(email) }> Email me a new code </Link>
        </>
      )
    } else if (modalState==="Loading") {
      return (
        <div className='container-for-loading'>
            <OtpLoadingView/>
        </div>
      )
    } else if (status==="SucessfulOTPEnrollment") {
      return <CompletionMessageComponent frState={frState} setStale={setStale} email={email} handleClosePreviousModal={handleClose} />
    }
  }

  const helperFunctionSubmit = () => {
    verifyOtpForm.handleSubmit();
    setError([])
  }

  const helperFunctionClose = () => {
    cleanupForm();
    setIsVerified(false);
    setModalState("info");
    handleClose();
  }

  const helperFunctionCancel = () => {
    cleanupForm();
    setPasswordOptions("password");
    handleClose();
    setModalState("info");
    setIsVerified(false);
    setError([]);
  }

  return (
      <Modal
        open={open}
        onClose={helperFunctionClose}
      >
        <ModalHeader onClose={helperFunctionClose}>{modalState==="Loading" ? "Please Wait..." : "Verify Your Identity" }</ModalHeader>
        <ModalBody>
          { renderView() }
        </ModalBody>
        <ModalFooter>
          { modalState !== "Loading" && (
              <ButtonGroup fullWidth orientation="vertical">
                <Button variant="primary" disabled={!isVerified } onClick={ ()=>{helperFunctionSubmit()} }>Submit</Button>
                <Button onClick={ ()=>{ helperFunctionCancel() } }>Cancel</Button>
              </ButtonGroup>
          )}
        </ModalFooter>
      </Modal>
  )
}